export var EDeadlineQuarter;
(function (EDeadlineQuarter) {
  EDeadlineQuarter["First"] = "first";
  EDeadlineQuarter["Fourth"] = "fourth";
  EDeadlineQuarter["Second"] = "second";
  EDeadlineQuarter["Third"] = "third";
})(EDeadlineQuarter || (EDeadlineQuarter = {}));
export var EDealType;
(function (EDealType) {
  EDealType["RentDay"] = "rentDay";
  EDealType["RentLong"] = "rentLong";
  EDealType["Sale"] = "sale";
})(EDealType || (EDealType = {}));
export var EOfferCategory;
(function (EOfferCategory) {
  EOfferCategory["SaleNovostroyka"] = "saleNovostroyka";
})(EOfferCategory || (EOfferCategory = {}));
export var EOfferType;
(function (EOfferType) {
  EOfferType["Commercial"] = "commercial";
  EOfferType["Flat"] = "flat";
  EOfferType["Newobject"] = "newobject";
  EOfferType["Suburban"] = "suburban";
})(EOfferType || (EOfferType = {}));